// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "user-status-modal" + "-" + chunkId + ".js?v=" + "2863b873cef4ef1ac34a" + "";
};